// extracted by mini-css-extract-plugin
module.exports = {"quickShopLink":"Wx-z","button":"Xx-z","disabled":"Yx-z"};